import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import ScrollableAnchor from "react-scrollable-anchor";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    menuCheckSelector,
    selectedMenuItemState,
    simpleFileState,
    surveyDataState,
    userState
} from "../../state/globalState";
import {DropzoneArea} from "material-ui-dropzone";
import DropzoneFileItem from "../common/DropzoneFileItem";
import {fileUploadToAzureStorage, findFilesByFileGcd} from "../../lib/api/file";
import {store} from "react-notifications-component";

/**
 * 설문 문항 컴포넌트
 */
const Survey15 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [simpleFiles, setSimpleFiles] = useRecoilState(simpleFileState);
    const ref = props.compRef[12];

    const setFocus = () => {
        ref.focus();
    }

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === "HC050005"))
            setSimpleFiles(files);
        }
    }

    const handleChange = async (files) => {
        if (simpleFiles.length > 0) {
            console.log("파일 1개만 가능");
            return;
        }

        const fileObj = files[0];

        if (fileObj !== undefined) {
            setSelectedMenuItem('SURVEY_33');

            // 실시간 파일 업로드
            const opts = {
                stdYear: userInfo.stdYear,
                admnNo: userInfo.admnNo,
                attcFileBizGcd: "hc056002",
                kognrFileGcd: "HC050005",
            }

            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode === "0000") {
                    setMenuCheck(true);
                    await getFiles(userInfo.admnNo, userInfo.stdYear);
                } else {
                    store.addNotification({
                        title: "알림",
                        message: "정상적인 연말정산 간소화 자료가 아닙니다.(암호화여부를 확인하세요)",
                        type: 'danger',
                        insert: "top",
                        container: "bottom-center",
                        animationIn: ["animated", "flipInX"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: false
                        },
                        width: 500
                    });
                }
            }
        }
    };

        return (
            <>
                <ScrollableAnchor id={"111"}>
                    <div>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[111].title}
                            sentences={surveyData[111].questions}
                            step={111}
                        />
                        <div>
                            <div>
                              <div className="blockquote-box">
                                <Box mb={2}>
                                  <Button target="_blank" variant="contained" color="primary"
                                          href="/pdf/홈택스 가이드 - 연말정산 간소화자료 받기.pdf">
                                    연말정산 간소화자료 다운로드 참조
                                  </Button>
                                </Box>
                                <div>
                                  국세청 홈택스에서 암호 없이 내려받기 한 "국세청 연말정산 간소화자료"파일만 업로드 가능합니다.
                                  반드시 회사 내부 보안을 해제하고 업로드 부탁드립니다.
                                </div>
                                <div>
                                  한번에 내려받기 한 파일과 상세내역을 함께 제출하고자 하시는 경우, 질문 9에는 한번에 내려받기 한 파일을 업로드 하시고, "상세내역"에 해당하는 파일은 질문 10에 업로드 부탁드립니다.
                                </div>
                              </div>
                              <br/>
                              <div style={{ marginLeft: '25px' }}>
                              <DropzoneArea
                                        acceptedFiles={['application/pdf']}
                                        filesLimit={0}
                                        dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                                        maxFileSize={30000000}
                                        // showFileNames={true}
                                        showPreviewsInDropzone={false}
                                        showAlerts={false}
                                        onChange={handleChange}
                                        // onDelete={handleDelete}
                                        // initialFiles={bizFile && bizFile.map((file) => file.name)}
                                    />
                                    {simpleFiles && simpleFiles.map((file) => <DropzoneFileItem key={file.fileUuid} {...file} />)}
                                </div>
                            </div>
                        </div>
                    </Container>
                    </div>
                </ScrollableAnchor>
            </>
        );
};

export default Survey15;
